import Layout from "../components/layout"
import React from "react"
import SEO from "../components/seo"

export default ({ data }) => (
  <Layout>
    <SEO />
    <section id="shop">
      <h2>
        <span>Shop</span>
      </h2>
      <h3>当サロンでは完全予約制になっております。</h3>
      <p>
        ご予約のキャンセルは前日17：00迄にお願い致します。
        <br />
        ご予約から15分以上遅れられた場合には、施術を受けられないこともございます。
      </p>
      <img src="/img/shop.jpg" />

      <ul className="shoplistHeader">
        <li className="pb">POWER BEAUTY</li>
        <li className="esthe">BiBi Esthétique</li>
        <li>
          <small>
            ※BiBi Esthétiqueは
            <br />
            ブライダルエステのみ行なっております。
          </small>
        </li>
      </ul>
      <center>
        <div className="content ">
          <dl className="pb">
            <dt>
              POWER BEAUTY
              <br />
              札幌店
            </dt>
            <dd>
              札幌市中央区大通西2丁目
              <br />
              都心ビル3階
              <br />
              スーパーカット大通店内
              <br />
              （個室）
              <br />
              TEL.(011)210-3636
              <br />
              営業時間 10:00～19:00
              <br />
              予約制/火曜定休
              <br />
              <a
                href="https://www.google.co.jp/maps/search/〒060-0061+北海道札幌市中央区南１条西５丁目+ホテルオークラ札幌"
                target="_blank"
                className="gmap"
              >
                <i className="fa fa-chevron-right" /> Google map
              </a>
            </dd>
          </dl>
          <dl className="pb">
            <dt>
              POWER BEAUTY
              <br />
              苫小牧店
            </dt>
            <dd>
              苫小牧市表町4丁目3-1
              <br />
              グランドホテルニュー王子 3F
              <br />
              TEL.(0144)31-6565
              <br />
              営業時間 10:00～19:00
              <br />
              年中無休
              <br />
              <a
                href="https://www.google.co.jp/maps/search/苫小牧市表町4丁目3-1+グランドホテルニュー王子"
                target="_blank"
                className="gmap"
              >
                <i className="fa fa-chevron-right" /> Google map
              </a>
            </dd>
          </dl>
          <dl className="esthe">
            <dt>
              BiBi Esthétique
              <br />
              青森店
            </dt>
            <dd>
              青森県青森市新町2丁目1-12
              <br />
              TEL.(017)723-0656
              <br />
              営業時間 10:00～19:00
              <br />
              毎週水曜日定休
              <br />
              <a
                href="https://www.google.co.jp/maps/search/青森県青森市新町2丁目1-12"
                target="_blank"
                className="gmap"
              >
                <i className="fa fa-chevron-right" /> Google map
              </a>
            </dd>
          </dl>
        </div>
      </center>
    </section>
  </Layout>
)
